import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import api from 'lib/api';
import getEnvironment from 'lib/env';
import { getToken, http, loginRequest } from 'lib/msal';

var FileItem = /*#__PURE__*/function (_Component) {
  _inherits(FileItem, _Component);

  var _super = _createSuper(FileItem);

  function FileItem(props) {
    var _this;

    _classCallCheck(this, FileItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setImage", function (element) {
      return _this.image = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.file != null) {
        if (_this.image == null) {
          return false;
        }

        if (_this.props.file.type.indexOf('image') > -1) {
          if (!_this.props.file.url) {
            api.getFile(_this.props.file.id).then(function (response) {
              var _assertThisInitialize, _assertThisInitialize2;

              var urlCreator = window.URL || window.webkitURL;
              var imageSRC = urlCreator.createObjectURL(response.data);

              if (((_assertThisInitialize = _assertThisInitialized(_this)) === null || _assertThisInitialize === void 0 ? void 0 : (_assertThisInitialize2 = _assertThisInitialize.props) === null || _assertThisInitialize2 === void 0 ? void 0 : _assertThisInitialize2.element) == 'div') {
                if (_this.image) {
                  _this.image.style.backgroundImage = 'url(' + imageSRC + ')';
                }

                return true;
              }

              _this.image.src = imageSRC;
            });
          } else {
            var _assertThisInitialize3, _assertThisInitialize4;

            if (((_assertThisInitialize3 = _assertThisInitialized(_this)) === null || _assertThisInitialize3 === void 0 ? void 0 : (_assertThisInitialize4 = _assertThisInitialize3.props) === null || _assertThisInitialize4 === void 0 ? void 0 : _assertThisInitialize4.element) == 'div') {
              if (_this.image) {
                _this.image.style.backgroundImage = 'url(' + _this.props.file.url + ')';
              }

              return true;
            }

            _this.image.src = _this.props.file.url;
          }
        } else {
          if (!_this.props.file.url) {
            var request = loginRequest;
            request.scopes = [].concat(_toConsumableArray(getEnvironment().scopes), _toConsumableArray(request.scopes));
            getToken(request).then(function (response) {
              _this.image.href = "".concat(http.defaults.baseURL, "/fileItems/").concat(_this.props.file.id, "?token=").concat(response.accessToken);
            });
          } else {
            _this.image.href = _this.props.file.url;
          }
        }
      }
    });

    _this.image = null;
    return _this;
  }

  _createClass(FileItem, [{
    key: "render",
    value: function render() {
      var eProps = _objectSpread({}, this.props);

      delete eProps.id;
      delete eProps.element;
      delete eProps.file;

      if (this.props.file == null) {
        return null;
      }

      if (this.props.file.type == null || this.props.file.id == null) {
        return null;
      }

      if (this.props.element == 'div') {
        return /*#__PURE__*/React.createElement("div", _extends({
          ref: this._setImage
        }, eProps));
      }

      if (this.props.file.type.indexOf('image') == -1) {
        return /*#__PURE__*/React.createElement("a", _extends({
          href: "",
          target: "_blank",
          ref: this._setImage
        }, eProps));
      }

      return /*#__PURE__*/React.createElement("img", _extends({
        ref: this._setImage
      }, eProps));
    }
  }]);

  return FileItem;
}(Component);

_defineProperty(FileItem, "defaultProps", {
  element: 'img'
});

export default FileItem;